// TODO: move this file to the component that's using it - it might be used in different places so keep it here

// TODO: rename this context to userDetails to make it more specific

import { createContext, useReducer, useEffect, ReactNode } from 'react'

export const AuthContext = createContext<any>('')

const user = JSON.parse(localStorage.getItem('user') ?? 'null')

const initialState = {
	user
}

interface AuthContextProviderProps {
	children: ReactNode
}

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
	const [state, dispatch] = useReducer(authReducer, initialState)

	const fetchUser = async () => {
		try {
			const response = await fetch(`/api/health/api/users/${user._id}`, {
				headers: {
					Authorization: `Bearer ${user.token}`
				}
			})

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			dispatch({
				type: 'UPDATE_USER',
				payload: {
					profilePicture: json?.profilePicture ?? null,
					booking: json?.booking ?? null
				}
			})
		} catch (error: any) {
			console.error(`Couldn't load your profile picture: ${error.message}`)
		}
	}

	// NOTE: on first load if user has local stored credentials, log them in and get their additional data
	useEffect(() => {
		if (user) {
			dispatch({ type: 'LOGIN', payload: user })
			fetchUser()
		}
	}, [])

	return <AuthContext.Provider value={{ ...state, dispatch }}>{children}</AuthContext.Provider>
}

export const authReducer = (state: any, action: any) => {
	switch (action.type) {
		case 'UPDATE_COMPANY': {
			const updatedCompany = {
				...state.user,
				team: action.payload
			}
			localStorage.setItem('user', JSON.stringify(updatedCompany))
			return { ...state, user: updatedCompany }
		}
		case 'UPDATE_COMPANY_NAME': {
			const updatedCompanyName = {
				...state.user,
				team: { ...state.user.team, name: action.payload }
			}
			localStorage.setItem('user', JSON.stringify(updatedCompanyName))
			return { ...state, user: updatedCompanyName }
		}
		case 'UPDATE_COMPANY_LOGO': {// NOTE: update the current user's company logo - on uploading new logo
			const updatedCompanyLogo = {
				...state.user,
				team: { ...state.user.team, companyLogo: action.payload }
			}
			localStorage.setItem('user', JSON.stringify(updatedCompanyLogo))
			return { ...state, user: updatedCompanyLogo }
		}
		case 'UPDATE_PROFILE_PIC': { // NOTE: update the users profile picture - on uploading new profile picture
			const updatedProfilePicture = { ...state.user, profilePicture: action.payload }
			localStorage.setItem('user', JSON.stringify(updatedProfilePicture))
			return { ...state, user: updatedProfilePicture }
		}
		case 'UPDATE_USER': { // NOTE: update user permissions (used by usePermissionSync)
			const updatedUser = {
				...state.user,
				...action.payload,
				team: action.payload.team ? { ...state.user.team, ...action.payload.team } : state.user.team
			}
			localStorage.setItem('user', JSON.stringify(updatedUser))
			return { ...state, user: updatedUser }
		}
		case 'LOGIN': {// NOTE: add the current user document to the context when logging in
			return { ...state, user: action.payload }
		}
		// TODO: clean company object and companyLogo on LOGOUT
		case 'LOGOUT': // NOTE: clean the user field when logging out to remove the data
			return { ...state, user: '' }
		default:
			return state
	}
}
